<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="SalesOrderItemsTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :show_toolbar_state="true" :isBusy="isBusy"
        :hb_table_class="'hb_table_so_main_items_class1'" :table_height_adjust="-8" :loading_width="40"
        @on_query="on_query" @tool_invoke="tool_invoke" tableref="a1d80ee56fba4cb2afbae160bf2b31eb">
        <template #query>
          {{ $t("common.sales_order_num") }}：<el-input clearable size="small" style="width: 150px"
            v-model="SalesId"></el-input>
          {{ $t("common.customer") + $t("common.num") }}：<el-input clearable size="small" style="width: 150px"
            v-model="AccountNum"></el-input>
          {{ $t("common.customer") + $t("common.name") }}：<el-input clearable size="small" style="width: 200px"
            v-model="SalesName"></el-input>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as SalesOrderItemsController from "../../controllers/sd/SalesOrderItemsController"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"

export default {
  name: "SalesOrderItems",
  components: {
    BaseContainer,
    TableMain,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_sales_order_detail",
      },
      fields: SalesOrderItemsController.fields.default,

      SalesName: "",
      AccountNum: "",
      SalesId: "",
      isBusy: false,
      all_role_users: [],
    }
  },
  created() {
    this.getAllRoleUsers()
  },
  methods: {
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy = true
      let _fromDate = "",
        _toDate = ""
      let _params = {}
      if (this.SalesName != "") {
        _params.SalesName = this.SalesName
      }
      if (this.AccountNum != "") {
        _params.CustAccount = this.AccountNum
      }
      if (this.SalesId != "") {
        _params.SalesId = this.SalesId
      }
      if (
        !_.isNull(date_range) &&
        this.AccountNum == "" &&
        this.SalesId == "" &&
        this.SalesName == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
      }
      set_data([])
      let _result = await SalesOrderItemsController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          t.price_state = t.SalesPrice == t.DiscPrice
          this.getApprover(t)
        })
        set_data(_.orderBy(_result[0], ["createdDateTime"], ["desc"]))
      }
      this.isBusy = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOApprover",
        "SOApprover",
        t.fcCheckSOApproved
      )
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOCreditControlApprover",
        "SOCreditControlApprover",
        t.fcCheckSOCreditControlApproved
      )
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOPriceDiffApprover",
        "SOPriceDiffApprover",
        t.fcCheckSOPriceDffApproved
      )
    },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: "table_sales_order_detail",
          sheet_title: "客户",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    //#endregion
  },
}
</script>
<style>
.hb_table_so_main_items_class1 {
  /* width: auto; */
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 360rem;
}
</style>
